import type { IInitiatedByOption } from "../interfaces/subscription";
import {
  SubscriptionCancellationReason,
  SubscriptionInitiatedByType,
} from "../interfaces/subscription";

/**
 * Subscription Cancellation Reason Option interface
 */
export interface ICancellationReasonOption {
  value: SubscriptionCancellationReason;
  label: string;
}

/**
 * Display constants
 */
export const DISPLAY_CONSTANTS = {
  NOT_AVAILABLE: "N/A",
} as const;

export const SUBSCRIPTION_INITIATED_BY_OPTIONS: IInitiatedByOption[] = [
  { value: SubscriptionInitiatedByType.CUSTOMER, label: "Customer" },
  { value: SubscriptionInitiatedByType.ADMIN, label: "Admin" },
];

export const CUSTOMER_CANCELLATION_REASON_OPTIONS: ICancellationReasonOption[] = [
  { value: SubscriptionCancellationReason.ADMIN_CUSTOMER_TOO_EXPENSIVE, label: "Too Expensive" },
  { value: SubscriptionCancellationReason.ADMIN_CUSTOMER_MOVING_TO_NEW_LOCATION, label: "Moving to New Location" },
  { value: SubscriptionCancellationReason.ADMIN_CUSTOMER_DOG_HEALTH_ISSUES, label: "Dog Health Issues" },
  { value: SubscriptionCancellationReason.ADMIN_CUSTOMER_NOT_SATISFIED_WITH_SERVICE, label: "Not Satisfied with Service" },
  { value: SubscriptionCancellationReason.ADMIN_CUSTOMER_FOUND_ANOTHER_SOLUTION, label: "Found Another Solution" },
  { value: SubscriptionCancellationReason.ADMIN_CUSTOMER_OTHER, label: "Other" },
];

export const ADMIN_CANCELLATION_REASON_OPTIONS: ICancellationReasonOption[] = [
  { value: SubscriptionCancellationReason.ADMIN_SUPPLY_ISSUE, label: "Supply Issue" },
  { value: SubscriptionCancellationReason.ADMIN_OTHERS, label: "Others" },
];

/** Pause subscription wizard — schedule step (new subscriptions) */
export const PAUSE_SUBSCRIPTION_SCHEDULE = {
  MIN_PAUSE_DAYS: 0,
  MAX_PAUSE_DAYS: 30,
  PREVIEW_DEBOUNCE_MS: 300,
} as const;
